/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const ZodiacOphiuchus = [
  ["path", { d: "M3 10A6.06 6.06 0 0 1 12 10 A6.06 6.06 0 0 0 21 10" }],
  ["path", { d: "M6 3v12a6 6 0 0 0 12 0V3" }]
];

export { ZodiacOphiuchus as default };
//# sourceMappingURL=zodiac-ophiuchus.js.map
